var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      class: [
        _vm.fundList.length < 7
          ? "row-class1"
          : _vm.fundList.length < 25
          ? "row-class2"
          : "row-class3",
      ],
    },
    [
      _c(
        "div",
        {
          class: [
            _vm.fundList.length < 7
              ? "area-body1"
              : _vm.fundList.length < 25
              ? "area-body2"
              : "area-body3",
          ],
        },
        [
          _c("div", { staticClass: "area-top" }, [
            _c("div", { staticClass: "area-steps" }, [
              _c("div", { staticClass: "area-step" }, [
                _c("div", { staticClass: "step-top1" }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "ea-nav" },
                  _vm._l(_vm.withoutSmallStepData, function (item, ii) {
                    return _c(
                      "div",
                      {
                        key: ii,
                        class: [
                          "ea-nav-item",
                          _vm.stepIndex >= ii ? "ea-nav-done" : "",
                          _vm.stepIndex == ii ? "ea-nav-active" : "",
                        ],
                      },
                      [
                        _c("div", { staticClass: "ea-nav-name" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(item.title) +
                              "\n                        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "ea-nav-progress" }, [
                          _c("div"),
                        ]),
                      ]
                    )
                  }),
                  0
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("transition", { attrs: { name: "fade" } }, [
            _vm.show1Div
              ? _c(
                  "div",
                  {
                    staticClass: "area-main",
                    class: { slideIn: _vm.showIn, slideOut: _vm.showOut },
                  },
                  [
                    _c("div", { staticClass: "area-content" }, [
                      _c("div", { staticClass: "content-title" }, [
                        _c("span", { staticClass: "title-text" }, [
                          _vm._v(
                            "\n                        创建组合\n                    "
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "content-main" }, [
                        _c("div", { staticClass: "zuhe-title" }, [
                          _c("span", { staticClass: "zuhe-name" }, [
                            _vm._v("组合名称 *"),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "zuhe-input" },
                          [
                            _c("el-input", {
                              attrs: {
                                placeholder: "请输入组合名称",
                                clearable: "",
                              },
                              model: {
                                value: _vm.reportName,
                                callback: function ($$v) {
                                  _vm.reportName = $$v
                                },
                                expression: "reportName",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "touma-title" }, [
                          _c("div", { staticClass: "touma-name" }, [
                            _vm._v("投资顾问"),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "touma-space" }),
                          _vm._v(" "),
                          _c("div", { staticClass: "touma-name" }, [
                            _vm._v("组合代码"),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "touma-input" }, [
                          _c(
                            "div",
                            { staticClass: "touma-value" },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "请输入投资顾问",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.counselor,
                                  callback: function ($$v) {
                                    _vm.counselor = $$v
                                  },
                                  expression: "counselor",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "touma-space" }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "touma-value" },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "请输入组合代码",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.reportCode,
                                  callback: function ($$v) {
                                    _vm.reportCode = $$v
                                  },
                                  expression: "reportCode",
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "timerebalance-title" }, [
                          _c("div", { staticClass: "touma-name" }, [
                            _vm._v("组合时间"),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "touma-space" }),
                          _vm._v(" "),
                          _c("div", { staticClass: "touma-name" }, [
                            _vm._v("再平衡周期*"),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "timerebalance-input" }, [
                          _c(
                            "div",
                            { staticClass: "touma-value2" },
                            [
                              _c("el-date-picker", {
                                staticClass: "portfolioDate_input left_float",
                                attrs: {
                                  size: "large",
                                  type: "date",
                                  placeholder: "选择日期",
                                },
                                model: {
                                  value: _vm.portfolioDate,
                                  callback: function ($$v) {
                                    _vm.portfolioDate = $$v
                                  },
                                  expression: "portfolioDate",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "touma-value3" },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "rebalanceFrequency_input",
                                  attrs: {
                                    width: "100px",
                                    "popper-class": "select-class",
                                  },
                                  model: {
                                    value: _vm.rebalanceFrequency,
                                    callback: function ($$v) {
                                      _vm.rebalanceFrequency = $$v
                                    },
                                    expression: "rebalanceFrequency",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    attrs: {
                                      selected: "selected",
                                      label: "买入并持有",
                                      value: "buyandhold",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("el-option", {
                                    attrs: { label: "月度", value: "monthly" },
                                  }),
                                  _vm._v(" "),
                                  _c("el-option", {
                                    attrs: {
                                      label: "季度",
                                      value: "quarterly",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("el-option", {
                                    attrs: {
                                      label: "半年度",
                                      value: "semi-annually",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("el-option", {
                                    attrs: { label: "年度", value: "annually" },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "risklevel-title" }, [
                          _c(
                            "div",
                            { staticClass: "risklevel-name" },
                            [
                              _c("el-checkbox", {
                                staticClass: "el-checkbox_overwrite1",
                                model: {
                                  value: _vm.isChangeRisk,
                                  callback: function ($$v) {
                                    _vm.isChangeRisk = $$v
                                  },
                                  expression: "isChangeRisk",
                                },
                              }),
                              _vm._v(
                                "\n                            风险等级稳定性调整\n                        "
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "risklevel-space" }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "risklevel-name" },
                            [
                              _c("el-checkbox", {
                                staticClass: "el-checkbox_overwrite2",
                                attrs: { size: "mini" },
                                model: {
                                  value: _vm.isSelectedEFAF,
                                  callback: function ($$v) {
                                    _vm.isSelectedEFAF = $$v
                                  },
                                  expression: "isSelectedEFAF",
                                },
                              }),
                              _vm._v(
                                "\n                            权益基金谨慎性调整\n                        "
                              ),
                            ],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "lasterrisk-title" }, [
                          _c("span", { staticClass: "lasterrisk-name" }, [
                            _vm._v("上期风险等级"),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "risk-input" },
                          [
                            _c(
                              "el-select",
                              {
                                staticClass: "lastRisk_input",
                                attrs: {
                                  disabled: !_vm.isChangeRisk,
                                  width: "100px",
                                  "popper-class": "select-class",
                                },
                                model: {
                                  value: _vm.lastRisk,
                                  callback: function ($$v) {
                                    _vm.lastRisk = $$v
                                  },
                                  expression: "lastRisk",
                                },
                              },
                              [
                                _c("el-option", {
                                  attrs: {
                                    selected: "selected",
                                    label: "低风险 R1",
                                    value: "1",
                                  },
                                }),
                                _vm._v(" "),
                                _c("el-option", {
                                  attrs: { label: "中低风险 R2", value: "2" },
                                }),
                                _vm._v(" "),
                                _c("el-option", {
                                  attrs: { label: "中风险 R3", value: "3" },
                                }),
                                _vm._v(" "),
                                _c("el-option", {
                                  attrs: { label: "中高风险 R4", value: "4" },
                                }),
                                _vm._v(" "),
                                _c("el-option", {
                                  attrs: { label: "高风险 R5", value: "5" },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]),
                    ]),
                  ]
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("transition", { attrs: { name: "fade" } }, [
            _vm.show2Div
              ? _c("div", { staticClass: "area-main" }, [
                  _c("div", { staticClass: "area-content" }, [
                    _c("div", { staticClass: "content-title" }, [
                      _c("span", { staticClass: "title-text" }, [
                        _vm._v(
                          "\n                        持仓信息\n                    "
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "content-main" }, [
                      _c("div", { staticClass: "funtion-area" }, [
                        _c(
                          "div",
                          { staticClass: "inout-div" },
                          [
                            _c(
                              "el-upload",
                              {
                                staticClass: "left_float",
                                attrs: {
                                  action: "https://morningstar.cn/",
                                  "on-change": _vm.importPortfolioHoldings,
                                  "auto-upload": false,
                                  "show-file-list": false,
                                },
                              },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      size: "medium",
                                      round: "",
                                      icon: "el-icon-upload2",
                                    },
                                  },
                                  [_vm._v("导入基金列表")]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "inout-div" }),
                        _vm._v(" "),
                        _c("div", { staticClass: "space-div" }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "inout2-div" },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "text" },
                                on: { click: _vm.downloadTemplateFile },
                              },
                              [_vm._v("下载Excel模板")]
                            ),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "fundList-title" },
                        [
                          _c(
                            "el-col",
                            {
                              staticClass: "div-right-border",
                              attrs: { span: 24 },
                            },
                            [
                              _c(
                                "el-table",
                                {
                                  key: _vm.tableKey,
                                  staticClass: "portfolioRiskTable",
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    data: _vm.fundList,
                                    "row-style": { height: "90px" },
                                  },
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: {
                                      fixed: "",
                                      type: "index",
                                      label: "序列",
                                      width: "80",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "symbol",
                                      label: "产品名称",
                                      "min-width": "130",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-popover",
                                                {
                                                  ref: "items_" + scope.$index,
                                                  attrs: {
                                                    placement: "bottom",
                                                    width: "320px",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "el-row",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "loading",
                                                          rawName: "v-loading",
                                                          value: _vm.loading2,
                                                          expression:
                                                            "loading2",
                                                        },
                                                      ],
                                                      staticStyle: {
                                                        width: "320px",
                                                        height: "300px",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "el-scrollbar",
                                                        {
                                                          ref: "search_scrollbar",
                                                          staticClass:
                                                            "scroll-no-horiz-bar",
                                                          staticStyle: {
                                                            height: "100%",
                                                          },
                                                        },
                                                        _vm._l(
                                                          _vm.state,
                                                          function (
                                                            node,
                                                            index
                                                          ) {
                                                            return _c(
                                                              "el-row",
                                                              {
                                                                key: index,
                                                                staticClass:
                                                                  "fundInformation",
                                                                staticStyle: {
                                                                  "text-align":
                                                                    "left",
                                                                  margin: "0",
                                                                  "font-size":
                                                                    "12px",
                                                                  cursor:
                                                                    "pointer",
                                                                },
                                                              },
                                                              [
                                                                _c("el-col", {
                                                                  ref:
                                                                    "cssClass" +
                                                                    index,
                                                                  refInFor: true,
                                                                  class: {
                                                                    searchHover:
                                                                      1 ===
                                                                      index,
                                                                  },
                                                                  attrs: {
                                                                    span: 24,
                                                                  },
                                                                  domProps: {
                                                                    innerHTML:
                                                                      _vm._s(
                                                                        node
                                                                      ),
                                                                  },
                                                                  nativeOn: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.getFundInformation(
                                                                          node
                                                                        )
                                                                      },
                                                                    mouseenter:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.changeClass(
                                                                          $event,
                                                                          index
                                                                        )
                                                                      },
                                                                  },
                                                                }),
                                                              ],
                                                              1
                                                            )
                                                          }
                                                        ),
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c("el-input", {
                                                    staticStyle: {
                                                      width: "82% !important",
                                                    },
                                                    attrs: {
                                                      slot: "reference",
                                                      placeholder: "",
                                                      type: "text",
                                                      "suffix-icon":
                                                        "el-icon-asset-search",
                                                    },
                                                    on: {
                                                      input: function ($event) {
                                                        return _vm.searchFundCache(
                                                          scope.row.symbolInfo,
                                                          scope.$index
                                                        )
                                                      },
                                                      focus: function ($event) {
                                                        return _vm.handleFocus(
                                                          scope.$index,
                                                          $event
                                                        )
                                                      },
                                                    },
                                                    slot: "reference",
                                                    model: {
                                                      value:
                                                        scope.row.symbolInfo,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "symbolInfo",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.symbolInfo",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      4052354132
                                    ),
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "weight",
                                      label: "权重分配%",
                                      "min-width": "60",
                                      align: "left",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c("el-input", {
                                                staticStyle: {
                                                  width: "80% !important",
                                                },
                                                attrs: {
                                                  type: "text",
                                                  placeholder: "",
                                                  "suffix-icon":
                                                    "el-icon-asset-percent",
                                                },
                                                on: {
                                                  blur: _vm.handleCalRatio,
                                                },
                                                model: {
                                                  value: scope.row.weight,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      "weight",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "scope.row.weight",
                                                },
                                              }),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      2920690366
                                    ),
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "weight1",
                                      "min-width": "20",
                                      align: "left",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c("i", {
                                                class:
                                                  scope.$index ==
                                                  _vm.fundList.length - 1
                                                    ? "el-icon-plus"
                                                    : "el-icon-close",
                                                staticStyle: {
                                                  "font-size": "26px",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.handleRemoveRecord(
                                                      scope.$index
                                                    )
                                                  },
                                                },
                                              }),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      1768923070
                                    ),
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "fenpei-area" }, [
                        _c(
                          "div",
                          { staticClass: "fenpei-div1" },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "info", round: "" },
                                on: { click: _vm.handleAvg },
                              },
                              [_vm._v("平均分配权重")]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "fenpei-space1" }),
                        _vm._v(" "),
                        _c("div", { staticClass: "fenpei-div2" }, [
                          _c("span", { staticClass: "fenpei-text" }, [
                            _vm._v("*  权重分配必须为100%"),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "fenpei-space2" }),
                      ]),
                    ]),
                  ]),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("transition", { attrs: { name: "fade" } }, [
            _vm.show3Div
              ? _c(
                  "div",
                  {
                    staticClass: "area-main",
                    class: { slideIn: _vm.showIn, slideOut: _vm.showOut },
                  },
                  [
                    _c("div", { staticClass: "area-content" }, [
                      _c("div", { staticClass: "content-title" }, [
                        _c("span", { staticClass: "title-text" }, [
                          _vm._v(
                            "\n                        诊断结果\n                    "
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "content-main risk-result-main" },
                        [
                          _c("div", { staticClass: "result-div" }, [
                            _c("div", { staticClass: "result-img" }),
                            _vm._v(" "),
                            _c("div", { staticClass: "result-text" }, [
                              _vm.totalRiskText == "1"
                                ? _c("span", [_vm._v("R1 低风险")])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.totalRiskText == "2"
                                ? _c("span", [_vm._v("R2 中低风险")])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.totalRiskText == "3"
                                ? _c("span", [_vm._v("R3 中风险")])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.totalRiskText == "4"
                                ? _c("span", [_vm._v("R4 中高风险")])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.totalRiskText == "5"
                                ? _c("span", [_vm._v("R5 高风险")])
                                : _vm._e(),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "result-space" }),
                            _vm._v(" "),
                            _vm.totalRiskText == "1"
                              ? _c("div", { staticClass: "result-steps1" })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.totalRiskText == "2"
                              ? _c("div", { staticClass: "result-steps2" })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.totalRiskText == "3"
                              ? _c("div", { staticClass: "result-steps3" })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.totalRiskText == "4"
                              ? _c("div", { staticClass: "result-steps4" })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.totalRiskText == "5"
                              ? _c("div", { staticClass: "result-steps5" })
                              : _vm._e(),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "calcuate-div" }, [
                            _c("div", { staticClass: "calcuate-title" }, [
                              _c("div", { staticClass: "sonrisk-div" }, [
                                _vm._v("子项风险"),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "sonrisk-space" }),
                              _vm._v(" "),
                              _c("div", { staticClass: "sonrisk-sum" }, [
                                _vm._v(
                                  "\n                                总体风险得分: "
                                ),
                                _c("span", { staticClass: "sum-text" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.totalRiskText.length === 1
                                        ? _vm.totalRiskText + ".0"
                                        : _vm.totalRiskText
                                    )
                                  ),
                                ]),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "calcuate-result" }, [
                              _c("div", { staticClass: "result-area" }, [
                                _c("div", { staticClass: "result-title" }, [
                                  _c("span", [_vm._v("组合持仓风险：")]),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "result-compass" },
                                  [
                                    _c("RiskScale", {
                                      attrs: { score: _vm.positionRiskScore },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "calcuate-space1" }, [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.positionRiskScore.length === 1
                                          ? _vm.positionRiskScore + ".0"
                                          : _vm.positionRiskScore
                                      )
                                    ),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "result-title" }, [
                                  _c("span", [_vm._v("下行波动风险：")]),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "result-compass" },
                                  [
                                    _c("RiskScale", {
                                      attrs: {
                                        score: _vm.downsideDeviationLevel,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "calcuate-space2" },
                                  [
                                    _c("sapn", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.downsideDeviationLevel.length ===
                                            1
                                            ? _vm.downsideDeviationLevel + ".0"
                                            : _vm.downsideDeviationLevel
                                        )
                                      ),
                                    ]),
                                  ],
                                  1
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "calcuate-result" }, [
                              _c("div", { staticClass: "result-area" }, [
                                _c("div", { staticClass: "result-title" }, [
                                  _c("span", [_vm._v("评级调整风险：")]),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "result-compass" },
                                  [
                                    _c("RiskScale", {
                                      attrs: {
                                        score: _vm.morningstarRiskLevel,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "calcuate-space1" }, [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.morningstarRiskLevel.length === 1
                                          ? _vm.morningstarRiskLevel + ".0"
                                          : _vm.morningstarRiskLevel
                                      )
                                    ),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "result-title" }, [
                                  _c("span", [_vm._v("附加规模风险：")]),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "result-compass" },
                                  [
                                    _c("RiskScale", {
                                      attrs: {
                                        score: _vm.additionalScaleScore,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "calcuate-space2" }, [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.additionalScaleScore.length === 1
                                          ? _vm.additionalScaleScore + ".0"
                                          : _vm.additionalScaleScore
                                      )
                                    ),
                                  ]),
                                ]),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "calcuate-result" }, [
                              _c("div", { staticClass: "result-area" }, [
                                _c("div", { staticClass: "result-title" }, [
                                  _c("span", [_vm._v("业绩波动风险：")]),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "result-compass" },
                                  [
                                    _c("RiskScale", {
                                      attrs: {
                                        score: _vm.standardDeviationLevel,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "calcuate-space1" }, [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.standardDeviationLevel.length === 1
                                          ? _vm.standardDeviationLevel + ".0"
                                          : _vm.standardDeviationLevel
                                      )
                                    ),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "result-title" }),
                                _vm._v(" "),
                                _c("div", { staticClass: "result-compass" }),
                                _vm._v(" "),
                                _c("div", { staticClass: "calcuate-space2" }),
                              ]),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "funtion-div" }, [
                            _c(
                              "div",
                              { staticClass: "funtion-export" },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      size: "small",
                                      icon: "el-icon-download",
                                      disabled: _vm.totalRisk === "",
                                      round: "",
                                    },
                                    on: { click: _vm.exportPortfolioHoldings },
                                  },
                                  [_vm._v("导出风险数据")]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "funtion-import" },
                              [
                                _vm.reportFlag === true ||
                                _vm.clickFlag === false
                                  ? _c(
                                      "el-button",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value:
                                              _vm.portfolioSuitabilityMemberSenior ||
                                              _vm.portfolioSuitabilityMemberBase,
                                            expression:
                                              "portfolioSuitabilityMemberSenior || portfolioSuitabilityMemberBase",
                                          },
                                        ],
                                        attrs: {
                                          size: "small",
                                          icon: "el-icon-document",
                                          disabled: !_vm.reportFlag,
                                          round: "",
                                        },
                                        on: { click: _vm.handleDown },
                                      },
                                      [_vm._v("下载PDF报告")]
                                    )
                                  : _c(
                                      "el-button",
                                      { attrs: { loading: true } },
                                      [_vm._v("报告生成中")]
                                    ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "funtion-space" }),
                          ]),
                        ]
                      ),
                    ]),
                  ]
                )
              : _vm._e(),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "floatPanel",
          staticStyle: {
            position: "absolute",
            bottom: "-66px",
            "z-index": "999",
            height: "110px",
            width: "100%",
            "background-color": "#ffffff",
          },
        },
        [
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showForwardButton,
                  expression: "showForwardButton",
                },
              ],
              staticStyle: {
                border: "0",
                "margin-right": "1076px",
                left: "10px",
                position: "absolute",
              },
              attrs: { size: "small", icon: "el-icon-arrow-left", round: "" },
              on: { click: _vm.forwardStep },
            },
            [_vm._v("返回")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showNextButton,
                  expression: "showNextButton",
                },
              ],
              staticStyle: { right: "20px", position: "absolute" },
              style: { "margin-left": _vm.marginLeft },
              attrs: { type: "primary", size: "small", round: "" },
              on: { click: _vm.nextStep },
            },
            [
              _vm._v(_vm._s(_vm.nextStepText)),
              _c("i", { staticClass: "el-icon-arrow-right el-icon--right" }),
            ]
          ),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c(
            "div",
            {
              attrs: {
                id: [
                  _vm.fundTextList.length < 23
                    ? "demo2"
                    : _vm.fundTextList.length < 50
                    ? "demo3"
                    : "demo4",
                ],
              },
            },
            [
              _c("div", { staticClass: "head-area" }, [
                _c("div", { staticClass: "head-content" }, [
                  _c("span", { staticClass: "head-date" }, [
                    _vm._v("报告生成日期：" + _vm._s(_vm.currentDate)),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "head-title" }, [
                    _vm._v(_vm._s(_vm.reportName) + "基金组合报告"),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "logo-img" }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "des-div" }, [
                _c("div", { staticClass: "des-msg" }, [
                  _c("div", { staticClass: "desc" }, [
                    _c("span", { staticClass: "desc-title" }, [
                      _vm._v("组合名称"),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "desc-content" }, [
                      _vm._v(_vm._s(_vm.reportName)),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "desc" }, [
                    _c("span", { staticClass: "desc-title" }, [
                      _vm._v("组合代码"),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "desc-content" }, [
                      _vm._v(_vm._s(_vm.reportCode)),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "desc" }, [
                    _c("span", { staticClass: "desc-title" }, [
                      _vm._v("组合持仓日期"),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "desc-content2" }, [
                      _vm._v(_vm._s(_vm.selectDate)),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "desc" }, [
                    _c("span", { staticClass: "desc-title" }, [
                      _vm._v("投资顾问"),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "desc-content" }, [
                      _vm._v(_vm._s(_vm.counselor)),
                    ]),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "comeupRisk-desc" }, [
                _c("div", { staticClass: "comeupRisk-div1" }, [
                  _c("span", { staticClass: "comeupRisk-title" }, [
                    _vm._v("组合综合风险综述"),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "comeupRisk-div2" }, [
                  _c("div", { staticClass: "comeupRisk-area" }, [
                    _c("span", { staticClass: "comeupRisk-text" }, [
                      _vm._v("该基金组合的综合风险评价为"),
                      _c("span", { staticStyle: { "font-weight": "600" } }, [
                        _vm._v(_vm._s(_vm.input1)),
                      ]),
                      _vm._v(
                        "。其中组合持仓风险为" +
                          _vm._s(_vm.input2) +
                          "，评级调整风险为" +
                          _vm._s(_vm.input3) +
                          "，业绩波动风险为" +
                          _vm._s(_vm.input4) +
                          "，下行波动风险为" +
                          _vm._s(_vm.input5) +
                          "，附加规模风险为" +
                          _vm._s(_vm.input6) +
                          "。该基金组合适合风险承受能力为" +
                          _vm._s(_vm.input7) +
                          "及以上的基金投资人购买。"
                      ),
                    ]),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "comeupRisk-desc" }, [
                _c("div", { staticClass: "comeupRisk-div1" }, [
                  _c("span", { staticClass: "evalRisk-title" }, [
                    _vm._v("风险评价"),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "comeupRisk-div2" }, [
                  _c("div", { staticClass: "evalRisk-div2" }, [
                    _c("div", { staticClass: "levelArea-div" }, [
                      _c("div", { staticClass: "area11" }, [
                        _vm._v(
                          "\n                            低(R1)\n                            "
                        ),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.allRiskType === 1,
                                expression: "allRiskType === 1",
                              },
                            ],
                            staticClass: "area-background",
                          },
                          [
                            _vm._v(
                              "\n                                低(R1) \n                            "
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "area12" }, [
                        _vm._v(
                          "\n                            中低(R2)\n                            "
                        ),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.allRiskType === 2,
                                expression: "allRiskType === 2",
                              },
                            ],
                            staticClass: "area-background",
                          },
                          [
                            _vm._v(
                              "\n                                中低(R2)\n                            "
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "area13" }, [
                        _vm._v(
                          "\n                            中(R3)\n                            "
                        ),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.allRiskType === 3,
                                expression: "allRiskType === 3",
                              },
                            ],
                            staticClass: "area-background",
                          },
                          [
                            _vm._v(
                              "\n                                中(R3)\n                            "
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "area14" }, [
                        _vm._v(
                          "\n                            中高(R4)\n                            "
                        ),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.allRiskType === 4,
                                expression: "allRiskType === 4",
                              },
                            ],
                            staticClass: "area-background",
                          },
                          [
                            _vm._v(
                              "\n                                中高(R4)\n                            "
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "area15" }, [
                        _vm._v(
                          "\n                            高(R5)\n                            "
                        ),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.allRiskType === 5,
                                expression: "allRiskType === 5",
                              },
                            ],
                            staticClass: "area-background",
                          },
                          [
                            _vm._v(
                              "\n                                高(R5)\n                            "
                            ),
                          ]
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "levelArea-div2" }, [
                      _c("div", { staticClass: "area2-div" }, [
                        _c("div", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.allRiskType === 1,
                              expression: "allRiskType === 1",
                            },
                          ],
                          staticClass: "area2",
                          staticStyle: {
                            width: "0",
                            height: "0",
                            "border-left": "10px solid transparent",
                            "border-right": "10px solid transparent",
                            "border-bottom": "20px solid black",
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "area2-div" }, [
                        _c("div", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.allRiskType === 2,
                              expression: "allRiskType === 2",
                            },
                          ],
                          staticClass: "area3",
                          staticStyle: {
                            width: "0",
                            height: "0",
                            "border-left": "10px solid transparent",
                            "border-right": "10px solid transparent",
                            "border-bottom": "20px solid black",
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "area2-div" }, [
                        _c("div", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.allRiskType === 3,
                              expression: "allRiskType === 3",
                            },
                          ],
                          staticClass: "area4",
                          staticStyle: {
                            width: "0",
                            height: "0",
                            "border-left": "10px solid transparent",
                            "border-right": "10px solid transparent",
                            "border-bottom": "20px solid black",
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "area2-div" }, [
                        _c("div", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.allRiskType === 4,
                              expression: "allRiskType === 4",
                            },
                          ],
                          staticClass: "area5",
                          staticStyle: {
                            width: "0",
                            height: "0",
                            "border-left": "10px solid transparent",
                            "border-right": "10px solid transparent",
                            "border-bottom": "20px solid black",
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "area2-div" }, [
                        _c("div", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.allRiskType === 5,
                              expression: "allRiskType === 5",
                            },
                          ],
                          staticClass: "area6",
                          staticStyle: {
                            width: "0",
                            height: "0",
                            "border-left": "10px solid transparent",
                            "border-right": "10px solid transparent",
                            "border-bottom": "20px solid black",
                          },
                        }),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "zixiang-desc" }, [
                _c("div", { staticClass: "zixiang-div1" }, [
                  _c("span", { staticClass: "comeupRisk-title" }, [
                    _vm._v("子项风险"),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "zixiang-div2" }, [
                  _c("div", { staticClass: "zixiang-div3" }, [
                    _c(
                      "div",
                      { staticClass: "item-div" },
                      [
                        _c("span", { staticClass: "item-text" }, [
                          _vm._v("组合持仓风险："),
                        ]),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          {
                            staticStyle: {
                              "margin-top": "16px",
                              "margin-left": "47px",
                            },
                            attrs: { span: 17 },
                          },
                          [
                            _c("el-progress", {
                              staticClass: "progress-bar2",
                              attrs: {
                                "text-inside": true,
                                "stroke-width": 13,
                                percentage: _vm.positionRiskScore_percentage,
                                format: _vm.progressFormat,
                                status: "warning",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "item-div" },
                      [
                        _c("span", { staticClass: "item-text" }, [
                          _vm._v("评级调整风险："),
                        ]),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          {
                            staticStyle: {
                              "margin-top": "16px",
                              "margin-left": "47px",
                            },
                            attrs: { span: 17 },
                          },
                          [
                            _c("el-progress", {
                              staticClass: "progress-bar2",
                              attrs: {
                                "text-inside": true,
                                "stroke-width": 13,
                                format: _vm.progressFormat,
                                percentage: _vm.morningstarRiskLevel_percentage,
                                status: "warning",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "item-div" },
                      [
                        _c("span", { staticClass: "item-text" }, [
                          _vm._v("业绩波动风险："),
                        ]),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          {
                            staticStyle: {
                              "margin-top": "16px",
                              "margin-left": "47px",
                            },
                            attrs: { span: 17 },
                          },
                          [
                            _c("el-progress", {
                              staticClass: "progress-bar2",
                              attrs: {
                                "text-inside": true,
                                "stroke-width": 13,
                                format: _vm.progressFormat,
                                percentage:
                                  _vm.standardDeviationLevel_percentage,
                                status: "warning",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "item-div" },
                      [
                        _c("span", { staticClass: "item-text" }, [
                          _vm._v("下行波动风险："),
                        ]),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          {
                            staticStyle: {
                              "margin-top": "16px",
                              "margin-left": "47px",
                            },
                            attrs: { span: 17 },
                          },
                          [
                            _c("el-progress", {
                              staticClass: "progress-bar2",
                              attrs: {
                                "text-inside": true,
                                "stroke-width": 13,
                                format: _vm.progressFormat,
                                percentage:
                                  _vm.downsideDeviationLevel_percentage,
                                status: "warning",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "item-div" },
                      [
                        _c("span", { staticClass: "item-text" }, [
                          _vm._v("总体风险得分："),
                        ]),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          {
                            staticStyle: {
                              "margin-top": "16px",
                              "margin-left": "47px",
                            },
                            attrs: { span: 17 },
                          },
                          [
                            _c("el-progress", {
                              staticClass: "progress-bar2",
                              attrs: {
                                "text-inside": true,
                                "stroke-width": 13,
                                format: _vm.progressFormat,
                                percentage: _vm.totalRisk_percentage,
                                status: "warning",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "item-div" },
                      [
                        _c("span", { staticClass: "item-text" }, [
                          _vm._v("附加规模风险："),
                        ]),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          {
                            staticStyle: {
                              "margin-top": "16px",
                              "margin-left": "47px",
                            },
                            attrs: { span: 17 },
                          },
                          [
                            _c("el-progress", {
                              staticClass: "progress-bar2",
                              attrs: {
                                "text-inside": true,
                                "stroke-width": 13,
                                format: _vm.progressFormat,
                                percentage: _vm.additionalScaleScore_percentage,
                                status: "warning",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "zixiang-div4" }, [
                    _c("div", { staticClass: "pingheng-div" }, [
                      _c("span", { staticStyle: { "font-weight": "600" } }, [
                        _vm._v("再平衡周期："),
                      ]),
                      _c("span", [_vm._v(_vm._s(_vm.balanceDateText))]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "pingheng-div" }, [
                      _c("span", { staticStyle: { "font-weight": "600" } }, [
                        _vm._v("业绩不足三年的基金占比："),
                      ]),
                      _c("span", [_vm._v(_vm._s(_vm.yjNotMoreText))]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "fengxian-div" }, [
                      _c("span", { staticStyle: { "font-weight": "600" } }, [
                        _vm._v("风险等级稳定性调整："),
                      ]),
                      _c("span", [_vm._v(_vm._s(_vm.riskLevelText))]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "fengxian-div" }, [
                      _c("span", { staticStyle: { "font-weight": "600" } }, [
                        _vm._v("上期风险等级："),
                      ]),
                      _c("span", [_vm._v(_vm._s(_vm.UpRiskLevelText))]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "fengxian-div" }, [
                      _c("span", { staticStyle: { "font-weight": "600" } }, [
                        _vm._v("权益基金谨慎性调整："),
                      ]),
                      _c("span", [_vm._v(_vm._s(_vm.qyFundText))]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "zixiang-div5" }, [
                    _c("span", [
                      _vm._v(
                        "注：基金组合的晨星风险、波动风险、下跌风险指标评价是基于全市场公募基金的评价结果。"
                      ),
                    ]),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "zuhe-desc" }, [
                _c("div", { staticClass: "zuhe-div1" }, [
                  _c("span", { staticClass: "comeupRisk-title" }, [
                    _vm._v("组合持仓信息"),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "zuhe-div2" }, [
                  _c(
                    "div",
                    { staticClass: "msg-div" },
                    [
                      _c("div", { staticClass: "msg-head" }, [
                        _c("div", { staticClass: "head1" }, [
                          _vm._v("基金代码"),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "head2" }, [
                          _vm._v("基金名称"),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "head3" }, [
                          _vm._v("基金类型"),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "head4" }, [
                          _vm._v("晨星评级(三年)"),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "head5" }, [
                          _vm._v("风险等级"),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "head6" }, [
                          _vm._v("持仓比例(%)"),
                        ]),
                      ]),
                      _vm._v(" "),
                      _vm._l(
                        _vm.fundTextList.slice(0, 4),
                        function (item, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "msg-content" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "head1",
                                  staticStyle: {
                                    "font-weight": "545",
                                    "font-size": "14px",
                                  },
                                },
                                [_vm._v(_vm._s(item.symbol))]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "head2",
                                  staticStyle: {
                                    "font-weight": "545",
                                    "font-size": "14px",
                                  },
                                },
                                [_vm._v(_vm._s(item.symbolInfo.slice(7, 100)))]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "head3",
                                  staticStyle: {
                                    "font-weight": "545",
                                    "font-size": "14px",
                                  },
                                },
                                [_vm._v(_vm._s(item.type))]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "head4",
                                  staticStyle: {
                                    "font-weight": "545",
                                    "font-size": "14px",
                                  },
                                },
                                [
                                  item.rank === "1"
                                    ? _c("div", { staticClass: "msg-star" }, [
                                        _c("div", { staticClass: "star" }),
                                      ])
                                    : item.rank === "2"
                                    ? _c("div", { staticClass: "msg-star" }, [
                                        _c("div", { staticClass: "star" }),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "star" }),
                                      ])
                                    : item.rank === "3"
                                    ? _c("div", { staticClass: "msg-star" }, [
                                        _c("div", { staticClass: "star" }),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "star" }),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "star" }),
                                      ])
                                    : item.rank === "4"
                                    ? _c("div", { staticClass: "msg-star" }, [
                                        _c("div", { staticClass: "star" }),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "star" }),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "star" }),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "star" }),
                                      ])
                                    : item.rank === "5"
                                    ? _c("div", { staticClass: "msg-star" }, [
                                        _c("div", { staticClass: "star" }),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "star" }),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "star" }),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "star" }),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "star" }),
                                      ])
                                    : _c("div", [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(item.rank) +
                                            "\n                            "
                                        ),
                                      ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "head5",
                                  staticStyle: {
                                    "font-weight": "545",
                                    "font-size": "14px",
                                  },
                                },
                                [_vm._v(_vm._s(item.level))]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "head6",
                                  staticStyle: {
                                    "font-weight": "545",
                                    "font-size": "14px",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(parseFloat(item.weight).toFixed(2))
                                  ),
                                ]
                              ),
                            ]
                          )
                        }
                      ),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.fundTextList.length < 5,
                          expression: "fundTextList.length < 5",
                        },
                      ],
                      staticClass: "msDate-area",
                    },
                    [
                      _c("div", { staticClass: "msDate-div" }, [
                        _vm._v("风险等级更新日期：" + _vm._s(_vm.riskDate)),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "msDate-div" }, [
                        _vm._v("晨星评级更新日期：" + _vm._s(_vm.ratingDate)),
                      ]),
                    ]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "comeupRisk-desc" }, [
                _c("div", { staticClass: "bottomlogo-div" }, [
                  _c("div", { staticClass: "ms-newlogo" }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "bottomtext-div" }, [
                  _c("div", { staticClass: "bottomText-area" }, [
                    _c("span", { staticClass: "comeupRisk-text" }, [
                      _vm._v(
                        "晨星（Morningstar）不保证信息的准确性、完整性和及时性，同时也不保证不会发生任何变更。此资料、数据、观点仅供参考，并不构成投资建议。在任何情况下，我公司不就本报告中的任何内容对任何投资行为做出任何形式的担保。本报告内容的版权归晨星资讯,(深圳)有限公司所有，未获得书面授权许可，不得以任何形式复制或用于制作报告、文件等用途。"
                      ),
                    ]),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "head-area" }, [
                _c("div", { staticClass: "head-content" }, [
                  _c("span", { staticClass: "head-date" }, [
                    _vm._v("报告生成日期：" + _vm._s(_vm.currentDate)),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "head-title" }, [
                    _vm._v(_vm._s(_vm.reportName) + "基金组合报告"),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "logo-img" }),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.fundTextList.length < 5,
                      expression: "fundTextList.length < 5",
                    },
                  ],
                  staticClass: "note-desc",
                },
                [
                  _c("div", { staticClass: "note-title" }, [
                    _c("span", { staticClass: "comeupRisk-title" }, [
                      _vm._v("备注"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "note-text" }, [
                    _c("div", { staticClass: "noteText-area" }, [
                      _c("div", { staticClass: "noteText-div1" }, [
                        _vm._v(
                          "根据中国证监会《关于做好公开募集证券投资基金投资顾问业务试点工作的通知》，试点机构从事基金投资顾问业务，应当按规定履行适当性义务，全面了解客户的情况，深入评估客户的风险识别能力、风险承受能力、投资目标，准确界定基金投资组合策略的风险特征，向客户提供符合其风险识别能力和承受能力的基金投资组合策略。"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "noteText-div2" }, [
                        _vm._v(
                          "试点机构应当合理评估、准确界定基金投资组合策略的风险特征，法律法规对特定基金品种合格投资人范围又特别规定的，相关基金投资组合策略的风险特征不得低于有关规定。"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "noteText-div2" }, [
                        _vm._v(
                          "本报告基金组合风险等级根据当前持仓信息计算，仅供参考。根据相关法律法规，建议至少每年重新评价基金组合风险，如遇市场环境重大变化、投资策略重要变更、组合成分基金显著调整等情形时应当及时更新。"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "noteText-div2" }, [
                        _c("span", { staticStyle: { "font-weight": "600" } }, [
                          _vm._v("数据来源："),
                        ]),
                        _vm._v(" 晨星 (中国) "),
                      ]),
                    ]),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.fundTextList.length < 5,
                      expression: "fundTextList.length < 5",
                    },
                  ],
                  staticClass: "comeupRisk-desc2",
                },
                [
                  _c("div", { staticClass: "bottomlogo-div" }, [
                    _c("div", { staticClass: "ms-newlogo" }),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "bottomtext-div" }, [
                    _c("div", { staticClass: "bottomText-area" }, [
                      _c("span", { staticClass: "comeupRisk-text" }, [
                        _vm._v(
                          "晨星（Morningstar）不保证信息的准确性、完整性和及时性，同时也不保证不会发生任何变更。此资料、数据、观点仅供参考，并不构成投资建议。在任何情况下，我公司不就本报告中的任何内容对任何投资行为做出任何形式的担保。本报告内容的版权归晨星资讯,(深圳)有限公司所有，未获得书面授权许可，不得以任何形式复制或用于制作报告、文件等用途。"
                        ),
                      ]),
                    ]),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.fundTextList.length > 4,
                      expression: "fundTextList.length > 4",
                    },
                  ],
                  staticClass: "zuhe-desc2",
                },
                [
                  _c("div", { staticClass: "zuhe-div1" }, [
                    _c("span", { staticClass: "comeupRisk-title" }, [
                      _vm._v("组合持仓信息"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "zuhe-div2" }, [
                    _c(
                      "div",
                      { staticClass: "msg-div" },
                      [
                        _c("div", { staticClass: "msg-head" }, [
                          _c("div", { staticClass: "head1" }, [
                            _vm._v("基金代码"),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "head2" }, [
                            _vm._v("基金名称"),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "head3" }, [
                            _vm._v("基金类型"),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "head4" }, [
                            _vm._v("晨星评级(三年)"),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "head5" }, [
                            _vm._v("风险等级"),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "head6" }, [
                            _vm._v("持仓比例(%)"),
                          ]),
                        ]),
                        _vm._v(" "),
                        _vm._l(
                          _vm.fundTextList.slice(4, 31),
                          function (item, index) {
                            return _c(
                              "div",
                              { key: index, staticClass: "msg-content" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "head1",
                                    staticStyle: {
                                      "font-weight": "545",
                                      "font-size": "14px",
                                    },
                                  },
                                  [_vm._v(_vm._s(item.symbol))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "head2",
                                    staticStyle: {
                                      "font-weight": "545",
                                      "font-size": "14px",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(item.symbolInfo.slice(7, 100))
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "head3",
                                    staticStyle: {
                                      "font-weight": "545",
                                      "font-size": "14px",
                                    },
                                  },
                                  [_vm._v(_vm._s(item.type))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "head4",
                                    staticStyle: {
                                      "font-weight": "545",
                                      "font-size": "14px",
                                    },
                                  },
                                  [
                                    item.rank === "1"
                                      ? _c("div", { staticClass: "msg-star" }, [
                                          _c("div", { staticClass: "star" }),
                                        ])
                                      : item.rank === "2"
                                      ? _c("div", { staticClass: "msg-star" }, [
                                          _c("div", { staticClass: "star" }),
                                          _vm._v(" "),
                                          _c("div", { staticClass: "star" }),
                                        ])
                                      : item.rank === "3"
                                      ? _c("div", { staticClass: "msg-star" }, [
                                          _c("div", { staticClass: "star" }),
                                          _vm._v(" "),
                                          _c("div", { staticClass: "star" }),
                                          _vm._v(" "),
                                          _c("div", { staticClass: "star" }),
                                        ])
                                      : item.rank === "4"
                                      ? _c("div", { staticClass: "msg-star" }, [
                                          _c("div", { staticClass: "star" }),
                                          _vm._v(" "),
                                          _c("div", { staticClass: "star" }),
                                          _vm._v(" "),
                                          _c("div", { staticClass: "star" }),
                                          _vm._v(" "),
                                          _c("div", { staticClass: "star" }),
                                        ])
                                      : item.rank === "5"
                                      ? _c("div", { staticClass: "msg-star" }, [
                                          _c("div", { staticClass: "star" }),
                                          _vm._v(" "),
                                          _c("div", { staticClass: "star" }),
                                          _vm._v(" "),
                                          _c("div", { staticClass: "star" }),
                                          _vm._v(" "),
                                          _c("div", { staticClass: "star" }),
                                          _vm._v(" "),
                                          _c("div", { staticClass: "star" }),
                                        ])
                                      : _c("div", [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(item.rank) +
                                              "\n                            "
                                          ),
                                        ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "head5",
                                    staticStyle: {
                                      "font-weight": "545",
                                      "font-size": "14px",
                                    },
                                  },
                                  [_vm._v(_vm._s(item.level))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "head6",
                                    staticStyle: {
                                      "font-weight": "545",
                                      "font-size": "14px",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(parseFloat(item.weight).toFixed(2))
                                    ),
                                  ]
                                ),
                              ]
                            )
                          }
                        ),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.fundTextList.length > 4 &&
                              _vm.fundTextList.length < 23,
                            expression:
                              "fundTextList.length > 4 && fundTextList.length < 23",
                          },
                        ],
                        staticClass: "msDate-area2",
                      },
                      [
                        _c("div", { staticClass: "msDate-div" }, [
                          _vm._v("风险等级更新日期：" + _vm._s(_vm.riskDate)),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "msDate-div" }, [
                          _vm._v("晨星评级更新日期：" + _vm._s(_vm.ratingDate)),
                        ]),
                      ]
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.fundTextList.length > 4 &&
                        _vm.fundTextList.length < 23,
                      expression:
                        "fundTextList.length > 4 && fundTextList.length < 23",
                    },
                  ],
                  staticClass: "note-desc2",
                },
                [
                  _c("div", { staticClass: "note-title" }, [
                    _c("span", { staticClass: "comeupRisk-title" }, [
                      _vm._v("备注"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "note-text" }, [
                    _c("div", { staticClass: "noteText-area" }, [
                      _c("div", { staticClass: "noteText-div1" }, [
                        _vm._v(
                          "根据中国证监会《关于做好公开募集证券投资基金投资顾问业务试点工作的通知》，试点机构从事基金投资顾问业务，应当按规定履行适当性义务，全面了解客户的情况，深入评估客户的风险识别能力、风险承受能力、投资目标，准确界定基金投资组合策略的风险特征，向客户提供符合其风险识别能力和承受能力的基金投资组合策略。"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "noteText-div2" }, [
                        _vm._v(
                          "试点机构应当合理评估、准确界定基金投资组合策略的风险特征，法律法规对特定基金品种合格投资人范围又特别规定的，相关基金投资组合策略的风险特征不得低于有关规定。"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "noteText-div2" }, [
                        _vm._v(
                          "本报告基金组合风险等级根据当前持仓信息计算，仅供参考。根据相关法律法规，建议至少每年重新评价基金组合风险，如遇市场环境重大变化、投资策略重要变更、组合成分基金显著调整等情形时应当及时更新。"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "noteText-div2" }, [
                        _c("span", { staticStyle: { "font-weight": "600" } }, [
                          _vm._v("数据来源："),
                        ]),
                        _vm._v(" 晨星 (中国) "),
                      ]),
                    ]),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.fundTextList.length > 22 &&
                        _vm.fundTextList.length < 31,
                      expression:
                        "fundTextList.length > 22 && fundTextList.length < 31",
                    },
                  ],
                  staticClass: "msDate-area3",
                },
                [
                  _c("div", { staticClass: "msDate-div" }, [
                    _vm._v("风险等级更新日期：" + _vm._s(_vm.riskDate)),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "msDate-div" }, [
                    _vm._v("晨星评级更新日期：" + _vm._s(_vm.ratingDate)),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.fundTextList.length > 4 &&
                        _vm.fundTextList.length < 23,
                      expression:
                        "fundTextList.length > 4 && fundTextList.length < 23",
                    },
                  ],
                  staticClass: "comeupRisk-desc3",
                },
                [
                  _c("div", { staticClass: "bottomlogo-div" }, [
                    _c("div", { staticClass: "ms-newlogo" }),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "bottomtext-div" }, [
                    _c("div", { staticClass: "bottomText-area" }, [
                      _c("span", { staticClass: "comeupRisk-text" }, [
                        _vm._v(
                          "晨星（Morningstar）不保证信息的准确性、完整性和及时性，同时也不保证不会发生任何变更。此资料、数据、观点仅供参考，并不构成投资建议。在任何情况下，我公司不就本报告中的任何内容对任何投资行为做出任何形式的担保。本报告内容的版权归晨星资讯,(深圳)有限公司所有，未获得书面授权许可，不得以任何形式复制或用于制作报告、文件等用途。"
                        ),
                      ]),
                    ]),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.fundTextList.length > 22,
                      expression: "fundTextList.length > 22",
                    },
                  ],
                  staticClass: "comeupRisk-desc4",
                },
                [
                  _c("div", { staticClass: "bottomlogo-div" }, [
                    _c("div", { staticClass: "ms-newlogo" }),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "bottomtext-div" }, [
                    _c("div", { staticClass: "bottomText-area" }, [
                      _c("span", { staticClass: "comeupRisk-text" }, [
                        _vm._v(
                          "晨星（Morningstar）不保证信息的准确性、完整性和及时性，同时也不保证不会发生任何变更。此资料、数据、观点仅供参考，并不构成投资建议。在任何情况下，我公司不就本报告中的任何内容对任何投资行为做出任何形式的担保。本报告内容的版权归晨星资讯,(深圳)有限公司所有，未获得书面授权许可，不得以任何形式复制或用于制作报告、文件等用途。"
                        ),
                      ]),
                    ]),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.fundTextList.length > 22,
                      expression: "fundTextList.length > 22",
                    },
                  ],
                  staticClass: "head-area",
                },
                [
                  _c("div", { staticClass: "head-content" }, [
                    _c("span", { staticClass: "head-date" }, [
                      _vm._v("报告生成日期：" + _vm._s(_vm.currentDate)),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "head-title" }, [
                      _vm._v(_vm._s(_vm.reportName) + "基金组合报告"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "logo-img" }),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.fundTextList.length > 22 &&
                        _vm.fundTextList.length < 31,
                      expression:
                        "fundTextList.length > 22 && fundTextList.length < 31",
                    },
                  ],
                  staticClass: "note-desc3",
                },
                [
                  _c("div", { staticClass: "note-title" }, [
                    _c("span", { staticClass: "comeupRisk-title" }, [
                      _vm._v("备注"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "note-text" }, [
                    _c("div", { staticClass: "noteText-area" }, [
                      _c("div", { staticClass: "noteText-div1" }, [
                        _vm._v(
                          "根据中国证监会《关于做好公开募集证券投资基金投资顾问业务试点工作的通知》，试点机构从事基金投资顾问业务，应当按规定履行适当性义务，全面了解客户的情况，深入评估客户的风险识别能力、风险承受能力、投资目标，准确界定基金投资组合策略的风险特征，向客户提供符合其风险识别能力和承受能力的基金投资组合策略。"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "noteText-div2" }, [
                        _vm._v(
                          "试点机构应当合理评估、准确界定基金投资组合策略的风险特征，法律法规对特定基金品种合格投资人范围又特别规定的，相关基金投资组合策略的风险特征不得低于有关规定。"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "noteText-div2" }, [
                        _vm._v(
                          "本报告基金组合风险等级根据当前持仓信息计算，仅供参考。根据相关法律法规，建议至少每年重新评价基金组合风险，如遇市场环境重大变化、投资策略重要变更、组合成分基金显著调整等情形时应当及时更新。"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "noteText-div2" }, [
                        _c("span", { staticStyle: { "font-weight": "600" } }, [
                          _vm._v("数据来源："),
                        ]),
                        _vm._v(" 晨星 (中国) "),
                      ]),
                    ]),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.fundTextList.length > 31,
                      expression: "fundTextList.length > 31",
                    },
                  ],
                  staticClass: "zuhe-desc2",
                },
                [
                  _c("div", { staticClass: "zuhe-div1" }, [
                    _c("span", { staticClass: "comeupRisk-title" }, [
                      _vm._v("组合持仓信息"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "zuhe-div2" }, [
                    _c(
                      "div",
                      { staticClass: "msg-div" },
                      [
                        _c("div", { staticClass: "msg-head" }, [
                          _c("div", { staticClass: "head1" }, [
                            _vm._v("基金代码"),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "head2" }, [
                            _vm._v("基金名称"),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "head3" }, [
                            _vm._v("基金类型"),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "head4" }, [
                            _vm._v("晨星评级(三年)"),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "head5" }, [
                            _vm._v("风险等级"),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "head6" }, [
                            _vm._v("持仓比例(%)"),
                          ]),
                        ]),
                        _vm._v(" "),
                        _vm._l(
                          _vm.fundTextList.slice(31, 57),
                          function (item, index) {
                            return _c(
                              "div",
                              { key: index, staticClass: "msg-content" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "head1",
                                    staticStyle: {
                                      "font-weight": "545",
                                      "font-size": "14px",
                                    },
                                  },
                                  [_vm._v(_vm._s(item.symbol))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "head2",
                                    staticStyle: {
                                      "font-weight": "545",
                                      "font-size": "14px",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(item.symbolInfo.slice(7, 100))
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "head3",
                                    staticStyle: {
                                      "font-weight": "545",
                                      "font-size": "14px",
                                    },
                                  },
                                  [_vm._v(_vm._s(item.type))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "head4",
                                    staticStyle: {
                                      "font-weight": "545",
                                      "font-size": "14px",
                                    },
                                  },
                                  [
                                    item.rank === "1"
                                      ? _c("div", { staticClass: "msg-star" }, [
                                          _c("div", { staticClass: "star" }),
                                        ])
                                      : item.rank === "2"
                                      ? _c("div", { staticClass: "msg-star" }, [
                                          _c("div", { staticClass: "star" }),
                                          _vm._v(" "),
                                          _c("div", { staticClass: "star" }),
                                        ])
                                      : item.rank === "3"
                                      ? _c("div", { staticClass: "msg-star" }, [
                                          _c("div", { staticClass: "star" }),
                                          _vm._v(" "),
                                          _c("div", { staticClass: "star" }),
                                          _vm._v(" "),
                                          _c("div", { staticClass: "star" }),
                                        ])
                                      : item.rank === "4"
                                      ? _c("div", { staticClass: "msg-star" }, [
                                          _c("div", { staticClass: "star" }),
                                          _vm._v(" "),
                                          _c("div", { staticClass: "star" }),
                                          _vm._v(" "),
                                          _c("div", { staticClass: "star" }),
                                          _vm._v(" "),
                                          _c("div", { staticClass: "star" }),
                                        ])
                                      : item.rank === "5"
                                      ? _c("div", { staticClass: "msg-star" }, [
                                          _c("div", { staticClass: "star" }),
                                          _vm._v(" "),
                                          _c("div", { staticClass: "star" }),
                                          _vm._v(" "),
                                          _c("div", { staticClass: "star" }),
                                          _vm._v(" "),
                                          _c("div", { staticClass: "star" }),
                                          _vm._v(" "),
                                          _c("div", { staticClass: "star" }),
                                        ])
                                      : _c("div", [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(item.rank) +
                                              "\n                            "
                                          ),
                                        ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "head5",
                                    staticStyle: {
                                      "font-weight": "545",
                                      "font-size": "14px",
                                    },
                                  },
                                  [_vm._v(_vm._s(item.level))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "head6",
                                    staticStyle: {
                                      "font-weight": "545",
                                      "font-size": "14px",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(parseFloat(item.weight).toFixed(2))
                                    ),
                                  ]
                                ),
                              ]
                            )
                          }
                        ),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.fundTextList.length > 4 &&
                              _vm.fundTextList.length < 23,
                            expression:
                              "fundTextList.length > 4 && fundTextList.length < 23",
                          },
                        ],
                        staticClass: "msDate-area2",
                      },
                      [
                        _c("div", { staticClass: "msDate-div" }, [
                          _vm._v("风险等级更新日期：" + _vm._s(_vm.riskDate)),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "msDate-div" }, [
                          _vm._v("晨星评级更新日期：" + _vm._s(_vm.ratingDate)),
                        ]),
                      ]
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.fundTextList.length > 30 &&
                        _vm.fundTextList.length < 50,
                      expression:
                        "fundTextList.length > 30 && fundTextList.length < 50",
                    },
                  ],
                  staticClass: "msDate-area4",
                },
                [
                  _c("div", { staticClass: "msDate-div" }, [
                    _vm._v("风险等级更新日期：" + _vm._s(_vm.riskDate)),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "msDate-div" }, [
                    _vm._v("晨星评级更新日期：" + _vm._s(_vm.ratingDate)),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.fundTextList.length > 30 &&
                        _vm.fundTextList.length < 50,
                      expression:
                        "fundTextList.length > 30 && fundTextList.length < 50",
                    },
                  ],
                  staticClass: "note-desc4",
                },
                [
                  _c("div", { staticClass: "note-title" }, [
                    _c("span", { staticClass: "comeupRisk-title" }, [
                      _vm._v("备注"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "note-text" }, [
                    _c("div", { staticClass: "noteText-area" }, [
                      _c("div", { staticClass: "noteText-div1" }, [
                        _vm._v(
                          "根据中国证监会《关于做好公开募集证券投资基金投资顾问业务试点工作的通知》，试点机构从事基金投资顾问业务，应当按规定履行适当性义务，全面了解客户的情况，深入评估客户的风险识别能力、风险承受能力、投资目标，准确界定基金投资组合策略的风险特征，向客户提供符合其风险识别能力和承受能力的基金投资组合策略。"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "noteText-div2" }, [
                        _vm._v(
                          "试点机构应当合理评估、准确界定基金投资组合策略的风险特征，法律法规对特定基金品种合格投资人范围又特别规定的，相关基金投资组合策略的风险特征不得低于有关规定。"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "noteText-div2" }, [
                        _vm._v(
                          "本报告基金组合风险等级根据当前持仓信息计算，仅供参考。根据相关法律法规，建议至少每年重新评价基金组合风险，如遇市场环境重大变化、投资策略重要变更、组合成分基金显著调整等情形时应当及时更新。"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "noteText-div2" }, [
                        _c("span", { staticStyle: { "font-weight": "600" } }, [
                          _vm._v("数据来源："),
                        ]),
                        _vm._v(" 晨星 (中国) "),
                      ]),
                    ]),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.fundTextList.length > 30 &&
                        _vm.fundTextList.length < 50,
                      expression:
                        "fundTextList.length > 30 && fundTextList.length < 50",
                    },
                  ],
                  staticClass: "comeupRisk-desc5",
                },
                [
                  _c("div", { staticClass: "bottomlogo-div" }, [
                    _c("div", { staticClass: "ms-newlogo" }),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "bottomtext-div" }, [
                    _c("div", { staticClass: "bottomText-area" }, [
                      _c("span", { staticClass: "comeupRisk-text" }, [
                        _vm._v(
                          "晨星（Morningstar）不保证信息的准确性、完整性和及时性，同时也不保证不会发生任何变更。此资料、数据、观点仅供参考，并不构成投资建议。在任何情况下，我公司不就本报告中的任何内容对任何投资行为做出任何形式的担保。本报告内容的版权归晨星资讯,(深圳)有限公司所有，未获得书面授权许可，不得以任何形式复制或用于制作报告、文件等用途。"
                        ),
                      ]),
                    ]),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.fundTextList.length > 49 &&
                        _vm.fundTextList.length < 58,
                      expression:
                        "fundTextList.length > 49 && fundTextList.length < 58",
                    },
                  ],
                  staticClass: "msDate-area5",
                },
                [
                  _c("div", { staticClass: "msDate-div" }, [
                    _vm._v("风险等级更新日期：" + _vm._s(_vm.riskDate)),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "msDate-div" }, [
                    _vm._v("晨星评级更新日期：" + _vm._s(_vm.ratingDate)),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.fundTextList.length > 49,
                      expression: "fundTextList.length > 49",
                    },
                  ],
                  staticClass: "comeupRisk-desc6",
                },
                [
                  _c("div", { staticClass: "bottomlogo-div" }, [
                    _c("div", { staticClass: "ms-newlogo" }),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "bottomtext-div" }, [
                    _c("div", { staticClass: "bottomText-area" }, [
                      _c("span", { staticClass: "comeupRisk-text" }, [
                        _vm._v(
                          "晨星（Morningstar）不保证信息的准确性、完整性和及时性，同时也不保证不会发生任何变更。此资料、数据、观点仅供参考，并不构成投资建议。在任何情况下，我公司不就本报告中的任何内容对任何投资行为做出任何形式的担保。本报告内容的版权归晨星资讯,(深圳)有限公司所有，未获得书面授权许可，不得以任何形式复制或用于制作报告、文件等用途。"
                        ),
                      ]),
                    ]),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.fundTextList.length > 22 &&
                        _vm.fundTextList.length < 31,
                      expression:
                        "fundTextList.length > 22 && fundTextList.length < 31",
                    },
                  ],
                  staticClass: "comeupRisk-desc7",
                },
                [
                  _c("div", { staticClass: "bottomlogo-div" }, [
                    _c("div", { staticClass: "ms-newlogo" }),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "bottomtext-div" }, [
                    _c("div", { staticClass: "bottomText-area" }, [
                      _c("span", { staticClass: "comeupRisk-text" }, [
                        _vm._v(
                          "晨星（Morningstar）不保证信息的准确性、完整性和及时性，同时也不保证不会发生任何变更。此资料、数据、观点仅供参考，并不构成投资建议。在任何情况下，我公司不就本报告中的任何内容对任何投资行为做出任何形式的担保。本报告内容的版权归晨星资讯,(深圳)有限公司所有，未获得书面授权许可，不得以任何形式复制或用于制作报告、文件等用途。"
                        ),
                      ]),
                    ]),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.fundTextList.length > 49,
                      expression: "fundTextList.length > 49",
                    },
                  ],
                  staticClass: "head-area",
                },
                [
                  _c("div", { staticClass: "head-content" }, [
                    _c("span", { staticClass: "head-date" }, [
                      _vm._v("报告生成日期：" + _vm._s(_vm.currentDate)),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "head-title" }, [
                      _vm._v(_vm._s(_vm.reportName) + "基金组合报告"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "logo-img" }),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.fundTextList.length > 49 &&
                        _vm.fundTextList.length < 58,
                      expression:
                        "fundTextList.length > 49 && fundTextList.length < 58",
                    },
                  ],
                  staticClass: "note-desc6",
                },
                [
                  _c("div", { staticClass: "note-title" }, [
                    _c("span", { staticClass: "comeupRisk-title" }, [
                      _vm._v("备注"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "note-text" }, [
                    _c("div", { staticClass: "noteText-area" }, [
                      _c("div", { staticClass: "noteText-div1" }, [
                        _vm._v(
                          "根据中国证监会《关于做好公开募集证券投资基金投资顾问业务试点工作的通知》，试点机构从事基金投资顾问业务，应当按规定履行适当性义务，全面了解客户的情况，深入评估客户的风险识别能力、风险承受能力、投资目标，准确界定基金投资组合策略的风险特征，向客户提供符合其风险识别能力和承受能力的基金投资组合策略。"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "noteText-div2" }, [
                        _vm._v(
                          "试点机构应当合理评估、准确界定基金投资组合策略的风险特征，法律法规对特定基金品种合格投资人范围又特别规定的，相关基金投资组合策略的风险特征不得低于有关规定。"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "noteText-div2" }, [
                        _vm._v(
                          "本报告基金组合风险等级根据当前持仓信息计算，仅供参考。根据相关法律法规，建议至少每年重新评价基金组合风险，如遇市场环境重大变化、投资策略重要变更、组合成分基金显著调整等情形时应当及时更新。"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "noteText-div2" }, [
                        _c("span", { staticStyle: { "font-weight": "600" } }, [
                          _vm._v("数据来源："),
                        ]),
                        _vm._v(" 晨星 (中国) "),
                      ]),
                    ]),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.fundTextList.length > 49 &&
                        _vm.fundTextList.length < 58,
                      expression:
                        "fundTextList.length > 49 && fundTextList.length < 58",
                    },
                  ],
                  staticClass: "comeupRisk-desc8",
                },
                [
                  _c("div", { staticClass: "bottomlogo-div" }, [
                    _c("div", { staticClass: "ms-newlogo" }),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "bottomtext-div" }, [
                    _c("div", { staticClass: "bottomText-area" }, [
                      _c("span", { staticClass: "comeupRisk-text" }, [
                        _vm._v(
                          "晨星（Morningstar）不保证信息的准确性、完整性和及时性，同时也不保证不会发生任何变更。此资料、数据、观点仅供参考，并不构成投资建议。在任何情况下，我公司不就本报告中的任何内容对任何投资行为做出任何形式的担保。本报告内容的版权归晨星资讯,(深圳)有限公司所有，未获得书面授权许可，不得以任何形式复制或用于制作报告、文件等用途。"
                        ),
                      ]),
                    ]),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.fundTextList.length > 57,
                      expression: "fundTextList.length > 57",
                    },
                  ],
                  staticClass: "zuhe-desc3",
                },
                [
                  _c("div", { staticClass: "zuhe-div1" }, [
                    _c("span", { staticClass: "comeupRisk-title" }, [
                      _vm._v("组合持仓信息"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "zuhe-div2" }, [
                    _c(
                      "div",
                      { staticClass: "msg-div" },
                      [
                        _c("div", { staticClass: "msg-head" }, [
                          _c("div", { staticClass: "head1" }, [
                            _vm._v("基金代码"),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "head2" }, [
                            _vm._v("基金名称"),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "head3" }, [
                            _vm._v("基金类型"),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "head4" }, [
                            _vm._v("晨星评级(三年)"),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "head5" }, [
                            _vm._v("风险等级"),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "head6" }, [
                            _vm._v("持仓比例(%)"),
                          ]),
                        ]),
                        _vm._v(" "),
                        _vm._l(
                          _vm.fundTextList.slice(57, 85),
                          function (item, index) {
                            return _c(
                              "div",
                              { key: index, staticClass: "msg-content" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "head1",
                                    staticStyle: {
                                      "font-weight": "545",
                                      "font-size": "14px",
                                    },
                                  },
                                  [_vm._v(_vm._s(item.symbol))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "head2",
                                    staticStyle: {
                                      "font-weight": "545",
                                      "font-size": "14px",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(item.symbolInfo.slice(7, 100))
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "head3",
                                    staticStyle: {
                                      "font-weight": "545",
                                      "font-size": "14px",
                                    },
                                  },
                                  [_vm._v(_vm._s(item.type))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "head4",
                                    staticStyle: {
                                      "font-weight": "545",
                                      "font-size": "14px",
                                    },
                                  },
                                  [
                                    item.rank === "1"
                                      ? _c("div", { staticClass: "msg-star" }, [
                                          _c("div", { staticClass: "star" }),
                                        ])
                                      : item.rank === "2"
                                      ? _c("div", { staticClass: "msg-star" }, [
                                          _c("div", { staticClass: "star" }),
                                          _vm._v(" "),
                                          _c("div", { staticClass: "star" }),
                                        ])
                                      : item.rank === "3"
                                      ? _c("div", { staticClass: "msg-star" }, [
                                          _c("div", { staticClass: "star" }),
                                          _vm._v(" "),
                                          _c("div", { staticClass: "star" }),
                                          _vm._v(" "),
                                          _c("div", { staticClass: "star" }),
                                        ])
                                      : item.rank === "4"
                                      ? _c("div", { staticClass: "msg-star" }, [
                                          _c("div", { staticClass: "star" }),
                                          _vm._v(" "),
                                          _c("div", { staticClass: "star" }),
                                          _vm._v(" "),
                                          _c("div", { staticClass: "star" }),
                                          _vm._v(" "),
                                          _c("div", { staticClass: "star" }),
                                        ])
                                      : item.rank === "5"
                                      ? _c("div", { staticClass: "msg-star" }, [
                                          _c("div", { staticClass: "star" }),
                                          _vm._v(" "),
                                          _c("div", { staticClass: "star" }),
                                          _vm._v(" "),
                                          _c("div", { staticClass: "star" }),
                                          _vm._v(" "),
                                          _c("div", { staticClass: "star" }),
                                          _vm._v(" "),
                                          _c("div", { staticClass: "star" }),
                                        ])
                                      : _c("div", [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(item.rank) +
                                              "\n                            "
                                          ),
                                        ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "head5",
                                    staticStyle: {
                                      "font-weight": "545",
                                      "font-size": "14px",
                                    },
                                  },
                                  [_vm._v(_vm._s(item.level))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "head6",
                                    staticStyle: {
                                      "font-weight": "545",
                                      "font-size": "14px",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(parseFloat(item.weight).toFixed(2))
                                    ),
                                  ]
                                ),
                              ]
                            )
                          }
                        ),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.fundTextList.length > 4 &&
                              _vm.fundTextList.length < 23,
                            expression:
                              "fundTextList.length > 4 && fundTextList.length < 23",
                          },
                        ],
                        staticClass: "msDate-area2",
                      },
                      [
                        _c("div", { staticClass: "msDate-div" }, [
                          _vm._v("风险等级更新日期：" + _vm._s(_vm.riskDate)),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "msDate-div" }, [
                          _vm._v("晨星评级更新日期：" + _vm._s(_vm.ratingDate)),
                        ]),
                      ]
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.fundTextList.length > 57,
                      expression: "fundTextList.length > 57",
                    },
                  ],
                  staticClass: "msDate-area9",
                },
                [
                  _c("div", { staticClass: "msDate-div" }, [
                    _vm._v("风险等级更新日期：" + _vm._s(_vm.riskDate)),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "msDate-div" }, [
                    _vm._v("晨星评级更新日期：" + _vm._s(_vm.ratingDate)),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.fundTextList.length > 57,
                      expression: "fundTextList.length > 57",
                    },
                  ],
                  staticClass: "note-desc9",
                },
                [
                  _c("div", { staticClass: "note-title" }, [
                    _c("span", { staticClass: "comeupRisk-title" }, [
                      _vm._v("备注"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "note-text" }, [
                    _c("div", { staticClass: "noteText-area" }, [
                      _c("div", { staticClass: "noteText-div1" }, [
                        _vm._v(
                          "根据中国证监会《关于做好公开募集证券投资基金投资顾问业务试点工作的通知》，试点机构从事基金投资顾问业务，应当按规定履行适当性义务，全面了解客户的情况，深入评估客户的风险识别能力、风险承受能力、投资目标，准确界定基金投资组合策略的风险特征，向客户提供符合其风险识别能力和承受能力的基金投资组合策略。"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "noteText-div2" }, [
                        _vm._v(
                          "试点机构应当合理评估、准确界定基金投资组合策略的风险特征，法律法规对特定基金品种合格投资人范围又特别规定的，相关基金投资组合策略的风险特征不得低于有关规定。"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "noteText-div2" }, [
                        _vm._v(
                          "本报告基金组合风险等级根据当前持仓信息计算，仅供参考。根据相关法律法规，建议至少每年重新评价基金组合风险，如遇市场环境重大变化、投资策略重要变更、组合成分基金显著调整等情形时应当及时更新。"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "noteText-div2" }, [
                        _c("span", { staticStyle: { "font-weight": "600" } }, [
                          _vm._v("数据来源："),
                        ]),
                        _vm._v(" 晨星 (中国) "),
                      ]),
                    ]),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.fundTextList.length > 57,
                      expression: "fundTextList.length > 57",
                    },
                  ],
                  staticClass: "comeupRisk-desc9",
                },
                [
                  _c("div", { staticClass: "bottomlogo-div" }, [
                    _c("div", { staticClass: "ms-newlogo" }),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "bottomtext-div" }, [
                    _c("div", { staticClass: "bottomText-area" }, [
                      _c("span", { staticClass: "comeupRisk-text" }, [
                        _vm._v(
                          "晨星（Morningstar）不保证信息的准确性、完整性和及时性，同时也不保证不会发生任何变更。此资料、数据、观点仅供参考，并不构成投资建议。在任何情况下，我公司不就本报告中的任何内容对任何投资行为做出任何形式的担保。本报告内容的版权归晨星资讯,(深圳)有限公司所有，未获得书面授权许可，不得以任何形式复制或用于制作报告、文件等用途。"
                        ),
                      ]),
                    ]),
                  ]),
                ]
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("br"),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }